import { createApiClient, redirectToSso } from "@alascorporation/api-client"
import { clearAuthSession, getToken, setMustChangePassword } from "./auth"
import { ssoConfig } from "./sso"

const api = createApiClient({
  baseURL: (import.meta.env.VITE_API_URL as string | undefined) ?? "/api",
  getToken,
  onUnauthorized: () => {
    clearAuthSession()
    if (!window.location.pathname.includes("/auth/callback")) {
      redirectToSso(ssoConfig, window.location.pathname + window.location.search)
    }
  },
  // Catches a mid-session gate (e.g. an admin resets this account's password
  // while it's already logged in elsewhere) — see
  // enforce-must-change-password-gate design.md Decision 5, Risk 3. Hard
  // navigation, consistent with onUnauthorized above: this module has no
  // router context, and ProtectedRoute only re-evaluates on navigation.
  onMustChangePassword: () => {
    setMustChangePassword(true)
    if (window.location.pathname !== "/change-password") {
      window.location.href = "/change-password"
    }
  },
})

export default api
